import { Offer } from "@comparaonline/offers-models";
import { usePromotion } from "../../../../../lib/promotionContext";

export const applyPromotionToOffers = (offers: Offer[]): Offer[] => {
  const { card } = usePromotion();

  if (!card) return offers;

  const {
    config: { flagUrl, productIds, name }
  } = card;

  return offers.map(offer => {
    const id = (offer.product && offer.product.id) || offer.id;
    if (productIds.includes(Number(id))) {
      offer.flagProps = {
        imgProps: {
          src: flagUrl,
          alt: name
        }
      };
    }
    return offer;
  });
};
